import { BaseEntity } from '../base-entity';
import { OrganisationWorkspaceDeployment } from './organisation-workspace-deployment';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export interface WorkspaceDeploymentFailure {
  workspaceDeploymentId: string;
  message: string;
  createdDate: Date;
  severity: string;
  tenantKey: string;
  type: string;
  workspaceDeployment: OrganisationWorkspaceDeployment;
}

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class WorkspaceDeploymentFailure extends BaseEntity {
  /// <code> Place custom code between <code> tags
  
  /// </code>
  // Generated code. Do not place code below this line.
}
